'use client';

import { useStyle } from '@/classify';
import CreateAccount from '@/components/CreateAccount';
import SignIn from '@/components/SignIn';
import { SESSION_SIGN_UP_SHARE_CODE_KEY, SIGN_UP_SHARE_CODE_URL_KEY } from '@/constants/shareCode';
import { useSignInPage } from '@/hooks/SignInPage/useSignInPage';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { Modal } from 'antd';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import defaultClasses from './signInPage.module.css';

const SignInPage = props => {
  const classes = useStyle(defaultClasses, props.classes);

  const talonProps = useSignInPage(props);

  const {
    username,
    handleAccountCreation,
    handleSignOut,
    handleForgotPassword,
    handleCancel,
    handleCreateAccount,
    updateUsername,
    showCreateAccount,
    onLoginSuccess,
    onCreateAccountSuccess,
    isModalOpen,
    onModalCancel,
    onButtonClick,
  } = talonProps;

  const { isMobile } = useIsMobile();

  const searchParams = useSearchParams();
  const queryEmail = searchParams.get('email') || '';
  const initialValues = useMemo(() => ({ email: queryEmail }), [queryEmail]);

  useEffect(() => {
    const shareCode = searchParams.get(SIGN_UP_SHARE_CODE_URL_KEY);

    if (shareCode) {
      sessionStorage.setItem(SESSION_SIGN_UP_SHARE_CODE_KEY, shareCode);
    }
  }, [searchParams]);

  return (
    <div className={classes.root}>
      {isMobile ? (
        <div className={classes.blocktitle}>
          <h2 className={[classes.header, classes.active].join(' ')}>
            <FormattedMessage
              id='signInPage.logintitle'
              defaultMessage='LOGIN'
            />
          </h2>
          <h2
            className={classes.header}
            onClick={showCreateAccount}
          >
            <FormattedMessage
              id='signInPage.registertitle'
              defaultMessage='REGISTER'
            />
          </h2>
        </div>
      ) : null}

      <div className={classes.contentContainer}>
        <div className={classes.signInContainer}>
          <SignIn
            setDefaultUsername={updateUsername}
            showCreateAccount={handleCreateAccount}
            showForgotPassword={handleForgotPassword}
            onLoginSuccess={onLoginSuccess}
            initialValues={initialValues}
          />
        </div>

        {isMobile ? null : (
          <div className={classes.createAccountContainer}>
            <CreateAccount
              initialValues={{
                email: username,
              }}
              isCancelButtonHidden={false}
              onSubmit={handleAccountCreation}
              onCancel={handleCancel}
              onCreateAccountSuccess={onCreateAccountSuccess}
            />
          </div>
        )}
      </div>

      <Modal
        open={isModalOpen}
        title={null}
        footer={null}
        width={800}
        onCancel={onModalCancel}
      >
        <div className={classes.modalContent}>
          <h2 className={classes.modalTitle}>thank you for registering! </h2>
          <p className={classes.modalInfo}>you just got a</p>
          <Image
            width={444}
            height={206}
            src={'/coupon-image.png'}
            className={classes.modalImage}
            alt='coupon'
          />
          <p
            className={classes.shopButton}
            onClick={onButtonClick}
          >
            Shop now
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default SignInPage;
